import { PANEL_BORDERS } from "@frontend/components/atoms/Panel/constants";

export const DRAWER_TAG_NAME = "drawer" as const;

export const DRAWER_FOOTER_TAG_NAME = "drawer-footer" as const;

export const DRAWER_BORDERS = PANEL_BORDERS;
